(function () {
  function initQuizProgress() {
    const progress = document.querySelector('.quiz-content__progress');
    if (!progress) return;

    const totalFromAttr = parseInt(progress.dataset.total || '0', 10);

    const getFieldsets = () => Array.from(document.querySelectorAll('fieldset.fieldset-cf7mls'));
    const getCurrentIndex = (fieldsets) => fieldsets.findIndex(fs => fs.classList.contains('cf7mls_current_fs'));

    const setProgress = (current, total) => {
      const textEl = progress.querySelector('.quiz-content__progress-text');
      const safeTotal = total || 1;
      const safeCurrent = Math.min(Math.max(current, 1), safeTotal);

      const percent = safeTotal === 1 ? 100 : ((safeCurrent - 1) / (safeTotal - 1)) * 100;

      progress.style.setProperty('--p', percent.toFixed(2));
      // if (textEl) textEl.textContent = `${safeCurrent}/${safeTotal}`;
      if (progress.classList.contains('is-done')) return;

      if (textEl) textEl.textContent = `${safeCurrent}/${safeTotal}`;
    };

    const setDone = () => {
      const textEl = progress.querySelector('.quiz-content__progress-text');
      progress.classList.add('is-done');
      if (textEl) {
        textEl.innerHTML = `
          <span class="quiz-content__progress-badge">
            <span class="quiz-content__progress-icon" aria-hidden="true">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <mask id="mask0_1830_5612" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
              <path d="M16 0H0V16H16V0Z" fill="white"/>
              </mask>
              <g mask="url(#mask0_1830_5612)">
              <path d="M7.27967 13.1664C7.08634 13.1664 6.89967 13.1397 6.74634 13.0797C4.46634 12.2997 0.833008 9.51307 0.833008 5.39307C0.833008 3.27973 2.53967 1.56641 4.63967 1.56641C5.64633 1.56641 6.58633 1.95306 7.28634 2.63973C7.99301 1.95306 8.92634 1.56641 9.93301 1.56641C12.033 1.56641 13.7397 3.27973 13.7397 5.39307C13.7397 5.67973 13.7197 5.97307 13.6797 6.27307C13.6597 6.42641 13.5663 6.5664 13.433 6.6464C13.2997 6.7264 13.133 6.73307 12.9863 6.67307C12.1663 6.31974 11.1463 6.58641 10.613 7.29973C10.5197 7.4264 10.3397 7.49307 10.213 7.49973C10.053 7.49973 9.90634 7.4264 9.81301 7.29973C9.43301 6.79307 8.85301 6.50641 8.22634 6.50641C7.13967 6.50641 6.25301 7.39973 6.25301 8.49973C6.25301 10.2331 7.24634 11.4664 8.08634 12.2064C8.20634 12.3131 8.26634 12.4664 8.25301 12.6264C8.23967 12.7864 8.15301 12.9264 8.01301 13.0131C7.93967 13.0531 7.87967 13.0797 7.84634 13.0864C7.67301 13.1397 7.47967 13.1664 7.27967 13.1664ZM4.63967 2.56641C3.093 2.56641 1.83301 3.83307 1.83301 5.39307C1.83301 8.87973 4.73301 11.0264 6.39968 11.8531C5.76635 11.0064 5.24634 9.8864 5.24634 8.49307C5.24634 6.83973 6.57967 5.49973 8.21967 5.49973C8.96634 5.49973 9.66634 5.77308 10.2063 6.25975C10.8797 5.65975 11.8397 5.38639 12.733 5.55306C12.733 5.49973 12.733 5.44641 12.733 5.39974C12.733 3.83974 11.473 2.57306 9.92634 2.57306C9.03967 2.57306 8.21967 2.98639 7.67967 3.69973C7.58634 3.82639 7.43967 3.89974 7.27967 3.89974C7.11967 3.89974 6.97301 3.82639 6.87967 3.69973C6.35301 2.97973 5.533 2.56641 4.63967 2.56641Z" fill="#8C70E9"/>
              <path d="M10.2131 14.4333C10.0597 14.4333 9.89974 14.4133 9.77307 14.3667C9.19974 14.1733 8.27307 13.7 7.42641 12.9467C6.43977 12.0733 5.25977 10.5933 5.25977 8.49333C5.25977 6.84 6.59309 5.5 8.23307 5.5C8.97974 5.5 9.67974 5.77334 10.2197 6.26001C11.0597 5.50667 12.3397 5.29333 13.3931 5.75333C14.4731 6.23333 15.1731 7.31333 15.1731 8.5C15.1731 11.66 12.3997 13.78 10.6531 14.3733C10.5197 14.4133 10.3664 14.4333 10.2131 14.4333ZM8.22641 6.5C7.13974 6.5 6.25309 7.39333 6.25309 8.49333C6.25309 10.2267 7.24641 11.46 8.08641 12.2C8.82641 12.8533 9.60641 13.26 10.0931 13.42C10.1464 13.44 10.2731 13.44 10.3197 13.42C11.3197 13.08 14.1664 11.4467 14.1664 8.49333C14.1664 7.7 13.6997 6.98 12.9864 6.66667C12.1797 6.31333 11.1464 6.58 10.6131 7.29333C10.5197 7.42 10.3397 7.48667 10.2131 7.49333C10.0531 7.49333 9.90641 7.42 9.81307 7.29333C9.43307 6.78667 8.85307 6.5 8.22641 6.5Z" fill="#8C70E9"/>
              </g>
              </svg>
            </span>
            Ти супер
          </span>`;
      }
    };

    window.quizProgressSetDone = setDone;

    const update = () => {
      const fieldsets = getFieldsets();
      if (!fieldsets.length) return;

      let total = totalFromAttr || fieldsets.length;
      let idx = getCurrentIndex(fieldsets);
      if (idx < 0) idx = 0;

      let current = idx + 1;

      if (totalFromAttr) {
        current = Math.min(current, totalFromAttr);
        total = totalFromAttr;
      }

      setProgress(current, total);
    };

    update();

    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.cf7mls_next, .cf7mls_prev');
      if (!btn) return;
      setTimeout(update, 60);
    });

    const obs = new MutationObserver(() => update());
    obs.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuizProgress);
  } else {
    initQuizProgress();
  }
})();